// extracted by mini-css-extract-plugin
export default {"content":"SectionContent_content__Hws+3"};